module.exports = __webpack_public_path__ + "web/img/journalinfo.46280fef.png";